import type { TextMeasurer } from '../../../../core/utils/text-measure.js';
import {
  HONEYCOMB_DEFAULT_MIN_ELLIPSIZED_TEXT,
  HONEYCOMB_LABEL_FONT_SIZE,
  HONEYCOMB_VALUE_LABEL_FONT_SIZE,
} from '../../../constants.js';
import { CanvasTextAreaProps } from '../../../types/canvas-text-area.js';

export const measureNodeTextContent = (
  value: string | number,
  name: string,
  textArea: CanvasTextAreaProps,
  labelMeasure: TextMeasurer,
  valueMeasure: TextMeasurer,
  labelFontSize: number = HONEYCOMB_LABEL_FONT_SIZE,
  valueFontSize: number = HONEYCOMB_VALUE_LABEL_FONT_SIZE,
) => {
  const nameWidth = labelMeasure(name, labelFontSize);
  const minNameWidth = labelMeasure(
    HONEYCOMB_DEFAULT_MIN_ELLIPSIZED_TEXT,
    labelFontSize,
  );

  const valueWidth = valueMeasure(value.toString(), valueFontSize);
  const minValueWidth = valueMeasure(
    HONEYCOMB_DEFAULT_MIN_ELLIPSIZED_TEXT,
    valueFontSize,
  );

  const valueHeight = valueFontSize;
  const isValueHeightFitting = valueHeight < textArea.height;
  const ableToRenderValue =
    isValueHeightFitting && typeof value === 'string'
      ? textArea.width > minValueWidth
      : valueWidth < textArea.width;

  const nameHeight = labelFontSize;
  const isNameHeightFitting = nameHeight < textArea.height;
  const ableToRenderName = isNameHeightFitting && textArea.width > minNameWidth;

  const totalHeight = valueHeight + valueHeight * 0.5 + nameHeight;
  const ableToRenderNothing = !ableToRenderValue && !ableToRenderName;
  const ableToRenderBoth =
    totalHeight < textArea.height && ableToRenderValue && ableToRenderName;

  return {
    valueHeight,
    nameHeight,
    ableToRenderNothing,
    ableToRenderBoth,
    valueWidth,
    nameWidth,
    ableToRenderName,
    ableToRenderValue,
  };
};
